import React, { useState } from 'react';

import SvgReportIcon from '../../../assets/svg/icon-daily-report.svg';

import { VitalItemSC } from '../components/vital-list/vital-list.styled';
import DailyReportSC from './daily-report.styled';
import Button from '../../../components/button';
import { useIntl } from 'react-intl';
import DailyReportModal from './daily-report-modal';

const DailyReport: React.FC = () => {
  const intl = useIntl();
  const [modalOpen, setModalOpen] = useState(false);

  const handleGenerateModalClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <DailyReportSC>
      <VitalItemSC>
        <div className="daily-report-widget__left">
          <img src={SvgReportIcon} alt="report_icon" />
        </div>
        <div className="daily-report-widget__right">
          <span>{intl.formatMessage({ id: 'life_id.daily_report_widget_heading' })}</span>
          <span>{intl.formatMessage({ id: 'life_id.daily_report_widget_subheading' })}</span>
          <Button
            size="SM"
            text="life_id.daily_report_widget_btn_txt"
            onClick={handleGenerateModalClick}
          />
        </div>
      </VitalItemSC>
      <DailyReportModal isOpen={modalOpen} onRequestClose={handleCloseModal} />
    </DailyReportSC>
  );
};

export default DailyReport;
